import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_374: DocMigration = {
  maxSchemaVersion: "0.0.374",
  description: "Update intersection effect type `OVERRIDE` to `MODIFY`, create `modifySettings` field",
  apply(json: any) {
    for (const optionSetId in json.optionSets) {
      const optionSet = json.optionSets[optionSetId];
      if (optionSet.optionSetType === "INTERSECTING" && optionSet.effect?.type === "OVERRIDE") {
        optionSet.effect.type = "MODIFY";
        optionSet.effect.modifySettings = {
          optionSetId: optionSet.effect.targetOptionSetId,
          fields: ["price", "builderOptionCode"],
        };
        delete optionSet.effect.targetOptionSetId;
        delete optionSet.effect.priceAdditive;
      }
    }
    return json;
  },
};

export default migration_0_0_374;
